import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCategoryById } from "../../services/tripServices";
import NewCategoryForm from "./newCategoryForm";

export default function EditCategory() {
    const { categoryId } = useParams();

    const [categoryData, setCategoryData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCategoryById(categoryId).then(data => {
            setCategoryData(data);
            setLoading(false);
        }).catch(error => {
            alert("Error fetching category data. Please try again.");
            setLoading(false);
        }); 
    }, [categoryId]);

    return loading ? (
        <section className="edit-trip">
            <h1>Loading Category Data...</h1>
        </section>
    ) : (
        <NewCategoryForm initialData={categoryData} />
    );
}